import { normalizeInternalPath } from '~/utils/normalizeInternalPath';

/**
 * Removes the trailing slashes from an internal path. Editors also enter links to pages of the app as absolute URLs,
 * so the function also removes them from an absolute URL with the origin of the app.
 * The function returns all other links without changes. This includes a protocol-relative link (`//host/path`),
 * because it points to a different host.
 */
export function normalizeInternalLink(link: string, appOrigin: string): string {
    if (link.startsWith('/') && !link.startsWith('//')) {
        return normalizeInternalPath(link);
    }

    try {
        const linkUrl = new URL(link);

        if (linkUrl.origin !== new URL(appOrigin).origin) {
            return link;
        }

        linkUrl.pathname = normalizeInternalPath(linkUrl.pathname);
        return linkUrl.href;
    } catch {
        return link;
    }
}
